import { useCookie, useRoute } from '#imports'

/**
 * Returns the persisted partner_promotion value for the current session.
 * The value is captured from the URL on first visit and stored in a session cookie.
 *
 * @returns The partner_promotion value or null if not set
 */
export function usePartnerPromotion(route = useRoute()) {
  const cookie = useCookie('partner_promotion', { maxAge: undefined })

  const promoCode =
    typeof route.query.utm_source === 'string' &&
    typeof route.query.promotion === 'string'
      ? route.query.promotion
      : (cookie.value ?? null)

  return { promoCode }
}
